module.exports = __webpack_public_path__ + "e43f77935ada60c1616ea19956f874c9.svg";